import React from 'react';
import BlockRenderer from '../blocks/BlockRenderer';

const ContentPage = ({ page }) => {
  return (
    <div>
      {page.blocks?.map(block => (
        <BlockRenderer key={block.id} block={block} />
      ))}
    </div>
  );
};

export default ContentPage;

